import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const usersCategories = [{ id: 'allUsrsEventId', setGenderParam: 'all', category: 'All users', faClass: 'users' }, { id: 'maleEventId', setGenderParam: 'male', category: 'Male users', faClass: 'male' }, { id: 'femaleEventId', setGenderParam: 'female', category: 'Female users', faClass: 'female' }]
const countries = [{ val: 'none', opt: 'None' }, { val: 'bz', opt: 'Brazil' }, { val: 'ng', opt: 'Nigeria' }, { val: 'us', opt: 'USA' }, { val: 'cn', opt: 'China' }, { val: 'ic', opt: 'Ivory Coast' }, { val: 'cb', opt: 'Cuba' }]

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App usersCategories={usersCategories} countries={countries} />
  </React.StrictMode>
);